import type { CSSProperties } from 'react';
import { Button, Headphones } from '../../../../modules/design-system';

export interface SuccessSectionProps {
  onAskQuestion: () => void;
}

/**
 * Top card on the Delivery Show page — confirmation that the request
 * has been submitted, plus a Customer Support entry point. Matches
 * Figma 361:132067.
 */
export function SuccessSection({ onAskQuestion }: SuccessSectionProps) {
  return (
    <section>
      <h3
        className="text-[16px] font-bold leading-[22px] tracking-[-0.3px]"
        style={{ color: 'var(--co-MyPacksItemCard-titleColor, #FFFFFF)' }}
      >
        You have provided all the necessary delivery information.
      </h3>
      <p
        className="mt-2 text-[14px] leading-[20px]"
        style={{ color: 'rgba(255,255,255,0.55)' }}
      >
        We'll process your request and send a payment invoice within 24-48 hours.
        You'll get a reminder via email and notifications.
      </p>

      <div
        className="my-4"
        style={{ borderTop: '1px solid rgba(255,255,255,0.10)' }}
      />

      <div
        className="flex items-center gap-2 text-[13px] font-bold tracking-[-0.3px]"
        style={{ color: 'var(--co-MyPacksItemCard-titleColor, #FFFFFF)' }}
      >
        <Headphones size={20} strokeWidth={1.8} />
        <span>Support</span>
      </div>
      <p
        className="mt-2 text-[14px] leading-[20px]"
        style={{ color: 'rgba(255,255,255,0.55)' }}
      >
        If you have any questions, please contact Customer Support.
      </p>

      <div className="mt-4">
        <Button
          variant="glass-frosted"
          size="md"
          onClick={onAskQuestion}
          style={{ '--co-Button-glass-frostedBorderWidth': 0 } as CSSProperties}
        >
          Ask a Question
        </Button>
      </div>
    </section>
  );
}
